import axios from 'axios';
// ---- external imports -----

import { getBaseUrl } from '../lib/helpers';
// ---- parent imports -----

import { getRequestHeaders } from './headers';
import { formatResponse } from './utlis';
import ApiService from './axiosInterceptor.service';
import { LEVEL_APIS } from '../endpoints';
// ---- local imports -----

class LevelService {
	async saveLevelData(gameUserId, level, missions, fs) {
		const data = { level, missions, financialStatements: fs };

		const response = await ApiService.request({
			method: 'PATCH',
			headers: getRequestHeaders(),
			data: JSON.stringify(data),
			url: `${getBaseUrl()}/game_users/${gameUserId}/${LEVEL_APIS.UPDATE_LEVEL}`
		});

		const formattedResponse = formatResponse(response);
		formattedResponse.data = response.data;

		return formattedResponse;
	}

	async loadLevelData(gameUserId) {
		const response = await axios.get(`${getBaseUrl()}/game_users/${gameUserId}/${LEVEL_APIS.LOAD_LEVEL}`, { headers: getRequestHeaders()});

		const formattedResponse = formatResponse(response);
		formattedResponse.data = { level: response.data.level, missions: response.data.missions };

		return formattedResponse;
	}
}

export default new LevelService();
